export class MeasureModel {

  public id?: number;
  public name?: string;
  public aggregation?: string;
  public unit?: number;
  public unitName?: string;
  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.aggregation = data.aggregation;
      this.unit = data.unit;
      this.unitName = data.unitName;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
    }
  }

  isValid() {
    return !!this.name && !!this.aggregation && !!this.unit
  }
}
